(function () {
  "use strict";

  if (window.LascalShippingEstimatorLoaded) {
    return;
  }

  window.LascalShippingEstimatorLoaded = true;

  const FREE_SHIPPING_DEFAULT = 5000; // £50.00 in pence

  let refreshTimer = null;
  let cartJsEventBound = false;

  function formatMoney(pence) {
    return (pence / 100).toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP"
    });
  }

  function addBusinessDays(date, days) {
    const result = new Date(date);

    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);

      const day = result.getDay();
      const isWeekday = day !== 0 && day !== 6;

      if (isWeekday) {
        added += 1;
      }
    }

    return result;
  }

  function formatShipDate(date) {
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short"
    });
  }

  function buildShippingMessage(amountPence, thresholdPence, options) {
    const shipByDate = formatShipDate(
      addBusinessDays(new Date(), 2)
    );

    const isProductMessage =
      options && options.context === "product";

    const cartTotalPence =
      options && options.cartTotalPence
        ? options.cartTotalPence
        : 0;

    if (
      isProductMessage &&
      cartTotalPence > 0 &&
      cartTotalPence < thresholdPence &&
      amountPence >= thresholdPence
    ) {
      return (
        "Add this item to unlock free delivery. " +
        "Ships by " +
        shipByDate +
        "."
      );
    }

    if (amountPence >= thresholdPence) {
      return (
        "Free delivery unlocked. " +
        "Ships by " +
        shipByDate +
        "."
      );
    }

    const remaining = thresholdPence - amountPence;

    return (
      "Add " +
      formatMoney(remaining) +
      " more for free delivery. " +
      "Ships by " +
      shipByDate +
      "."
    );
  }

  function updatePromiseElement(element, amountPence, options) {
    if (!element) {
      return;
    }

    const thresholdPence = parseInt(
      element.getAttribute("data-free-shipping-threshold") ||
        FREE_SHIPPING_DEFAULT,
      10
    );

    const textElement = element.querySelector(
      "[data-shipping-promise-text]"
    );

    if (!textElement) {
      return;
    }

    textElement.textContent = buildShippingMessage(
      amountPence,
      thresholdPence,
      options
    );
  }

  function getCartUrl() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root + "cart.js";
    }

    return "/cart.js";
  }

  function getCart() {
    return fetch(getCartUrl(), {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Could not load the cart.");
        }

        return response.json();
      })
      .catch(function (error) {
        console.warn(
          "Could not read the cart for the delivery promise.",
          error
        );

        return null;
      });
  }

  function updateProductShippingPromise(cartTotalPence) {
    const promiseElement = document.querySelector(
      "[data-product-shipping-promise]"
    );

    if (!promiseElement) {
      return;
    }

    const productPrice = parseInt(
      promiseElement.getAttribute("data-current-price") || "0",
      10
    );

    const combinedAmount = cartTotalPence + productPrice;

    updatePromiseElement(
      promiseElement,
      combinedAmount,
      {
        context: "product",
        cartTotalPence: cartTotalPence
      }
    );
  }

  function updateCartShippingPromise(cartTotalPence) {
    const promiseElement = document.querySelector(
      "[data-cart-shipping-promise]"
    );

    if (!promiseElement) {
      return;
    }

    updatePromiseElement(
      promiseElement,
      cartTotalPence,
      {
        context: "cart",
        cartTotalPence: cartTotalPence
      }
    );
  }

  function updateFromCart(cart) {
    if (!cart) {
      return;
    }

    const cartTotalPence = parseInt(
      cart.total_price || 0,
      10
    );

    updateProductShippingPromise(cartTotalPence);
    updateCartShippingPromise(cartTotalPence);
  }

  function updateAllShippingPromises() {
    return getCart().then(function (cart) {
      updateFromCart(cart);
    });
  }

  function scheduleUpdate(delay) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(
      updateAllShippingPromises,
      typeof delay === "number" ? delay : 100
    );
  }

  function runDelayedUpdates() {
    [100, 500, 1000, 1500].forEach(function (delay) {
      window.setTimeout(
        updateAllShippingPromises,
        delay
      );
    });
  }

  function bindCartJsEvent() {
    if (
      cartJsEventBound ||
      !window.jQuery
    ) {
      return;
    }

    cartJsEventBound = true;

    window.jQuery(document).on(
      "cart.requestComplete",
      function (event, cart) {
        if (
          cart &&
          typeof cart.total_price !== "undefined"
        ) {
          updateFromCart(cart);
        } else {
          scheduleUpdate(50);
        }
      }
    );
  }

  function initialiseShippingEstimator() {
    bindCartJsEvent();
    updateAllShippingPromises();

    /*
     * Retry the CartJS binding in case the theme's main bundle
     * finishes loading shortly after this file.
     */
    window.setTimeout(bindCartJsEvent, 500);
    window.setTimeout(bindCartJsEvent, 1500);

    document.addEventListener("click", function (event) {
      const cartAction = event.target.closest(
        [
          "[data-cart-update]",
          "[data-cart-remove]",
          ".ajax-cart__quantity-block",
          '[name="add"]',
          ".product-form__submit",
          ".product__card-add-cart",
          "[data-cart-submit]"
        ].join(",")
      );

      if (cartAction) {
        runDelayedUpdates();
      }
    });

    document.addEventListener("submit", function (event) {
      if (
        event.target.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        runDelayedUpdates();
      }
    });

    /*
     * Refresh when returning to the page from browser history.
     */
    window.addEventListener("pageshow", function () {
      scheduleUpdate(50);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseShippingEstimator
    );
  } else {
    initialiseShippingEstimator();
  }
})();